/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: Z3sr4fle2ZRR

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Table from "../../Table"; // plasmic-import: h6WonSNfUsoV/component
import TableThead from "../../TableThead"; // plasmic-import: sYX9BWa2o65b/component
import TableTr from "../../TableTr"; // plasmic-import: ClRepu2PwVaX/component
import TableTh from "../../TableTh"; // plasmic-import: RjYJ6AJe84Rc/component
import TableTbody from "../../TableTbody"; // plasmic-import: 8BlIXCfTLl3k/component
import TableTd from "../../TableTd"; // plasmic-import: yk0RhbxcMVQJ/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { RawNull } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawNull/RawNull"; // plasmic-import: P90l9-wwCsyV/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicPricingProducts.module.css"; // plasmic-import: Z3sr4fle2ZRR/css

import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicPricingProducts__VariantMembers = {};
export type PlasmicPricingProducts__VariantsArgs = {};
type VariantPropType = keyof PlasmicPricingProducts__VariantsArgs;
export const PlasmicPricingProducts__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPricingProducts__ArgsType = {
  onRequestInfoClick?: () => void;
};
type ArgPropType = keyof PlasmicPricingProducts__ArgsType;
export const PlasmicPricingProducts__ArgProps = new Array<ArgPropType>(
  "onRequestInfoClick"
);

export type PlasmicPricingProducts__OverridesType = {
  products?: Flex__<"section">;
  desktop?: Flex__<"div">;
  left?: Flex__<"div">;
  product?: Flex__<"div">;
  header?: Flex__<"header">;
  top4?: Flex__<"div">;
  tagline?: Flex__<"h3">;
  containter?: Flex__<"div">;
  logo4?: Flex__<"div">;
  text?: Flex__<"div">;
  title9?: Flex__<"p">;
  program?: Flex__<"div">;
  col?: Flex__<"div">;
  header2?: Flex__<"div">;
  tagline3?: Flex__<"h2">;
  title2?: Flex__<"p">;
  col2?: Flex__<"div">;
  section?: Flex__<"div">;
  title3?: Flex__<"h4">;
  contents?: Flex__<"div">;
  button?: Flex__<typeof Button>;
  pricing?: Flex__<"div">;
  header3?: Flex__<"header">;
  tagline4?: Flex__<"h2">;
  title4?: Flex__<"p">;
  button2?: Flex__<typeof Button>;
  right?: Flex__<"div">;
  product2?: Flex__<"div">;
  header4?: Flex__<"header">;
  top2?: Flex__<"div">;
  tagline5?: Flex__<"h3">;
  logo?: Flex__<"div">;
  text32?: Flex__<"div">;
  title5?: Flex__<"p">;
  program3?: Flex__<"div">;
  title6?: Flex__<"p">;
  button3?: Flex__<typeof Button>;
  product3?: Flex__<"div">;
  header5?: Flex__<"header">;
  top3?: Flex__<"div">;
  tagline7?: Flex__<"h3">;
  logo2?: Flex__<"div">;
  text2?: Flex__<"div">;
  title7?: Flex__<"p">;
  program4?: Flex__<"div">;
  title8?: Flex__<"p">;
  button4?: Flex__<typeof Button>;
  mask?: Flex__<"div">;
  rawNull?: Flex__<typeof RawNull>;
  mobile?: Flex__<"div">;
  product4?: Flex__<"div">;
  header6?: Flex__<"div">;
  top5?: Flex__<"div">;
  tagline9?: Flex__<"h3">;
  containter2?: Flex__<"div">;
  logo5?: Flex__<"div">;
  text3?: Flex__<"div">;
  title10?: Flex__<"p">;
  program2?: Flex__<"div">;
  col3?: Flex__<"div">;
  header7?: Flex__<"div">;
  tagline11?: Flex__<"h2">;
  title11?: Flex__<"p">;
  col4?: Flex__<"div">;
  section2?: Flex__<"div">;
  title12?: Flex__<"h4">;
  contents2?: Flex__<"div">;
  contentsItem4?: Flex__<"div">;
  icon4?: Flex__<"div">;
  text19?: Flex__<"div">;
  contentsItem5?: Flex__<"div">;
  icon5?: Flex__<"div">;
  text20?: Flex__<"div">;
  contentsItem6?: Flex__<"div">;
  icon6?: Flex__<"div">;
  text21?: Flex__<"div">;
  button5?: Flex__<typeof Button>;
  pricing2?: Flex__<"div">;
  header8?: Flex__<"div">;
  tagline12?: Flex__<"h2">;
  title13?: Flex__<"p">;
  button6?: Flex__<typeof Button>;
  product5?: Flex__<"div">;
  header9?: Flex__<"div">;
  top6?: Flex__<"div">;
  tagline13?: Flex__<"h3">;
  logo3?: Flex__<"div">;
  text33?: Flex__<"div">;
  title14?: Flex__<"p">;
  program5?: Flex__<"div">;
  title15?: Flex__<"p">;
  button7?: Flex__<typeof Button>;
  product6?: Flex__<"div">;
  header10?: Flex__<"div">;
  top7?: Flex__<"div">;
  tagline15?: Flex__<"h3">;
  logo6?: Flex__<"div">;
  text4?: Flex__<"div">;
  title16?: Flex__<"p">;
  program6?: Flex__<"div">;
  title17?: Flex__<"p">;
  button8?: Flex__<typeof Button>;
  button9?: Flex__<typeof Button>;
};

export interface DefaultPricingProductsProps {
  onRequestInfoClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicPricingProducts__RenderFunc(props: {
  variants: PlasmicPricingProducts__VariantsArgs;
  args: PlasmicPricingProducts__ArgsType;
  overrides: PlasmicPricingProducts__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"products"}
      data-plasmic-override={overrides.products}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.products
      )}
    >
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames(projectcss.all, sty.desktop)}
        >
          <div
            data-plasmic-name={"left"}
            data-plasmic-override={overrides.left}
            className={classNames(projectcss.all, sty.left)}
          >
            <div
              data-plasmic-name={"product"}
              data-plasmic-override={overrides.product}
              className={classNames(projectcss.all, sty.product)}
            >
              <header
                data-plasmic-name={"header"}
                data-plasmic-override={overrides.header}
                className={classNames(projectcss.all, sty.header)}
              >
                <div
                  data-plasmic-name={"top4"}
                  data-plasmic-override={overrides.top4}
                  className={classNames(projectcss.all, sty.top4)}
                >
                  <h3
                    data-plasmic-name={"tagline"}
                    data-plasmic-override={overrides.tagline}
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.tagline
                    )}
                  >
                    {"Product"}
                  </h3>
                  <div
                    data-plasmic-name={"containter"}
                    data-plasmic-override={overrides.containter}
                    className={classNames(projectcss.all, sty.containter)}
                  >
                    <div
                      data-plasmic-name={"logo4"}
                      data-plasmic-override={overrides.logo4}
                      className={classNames(projectcss.all, sty.logo4)}
                    >
                      <PlasmicImg__
                        alt={"MyEvaluations logo"}
                        className={classNames(sty.img___8ARSa)}
                        displayHeight={"39.775px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"226.5px"}
                        loader={"plasmic"}
                        loading={"lazy"}
                        src={{
                          src: "https://site-assets.plasmic.app/ede322bb13fcecbd89105313898ea953.svg",
                          fullWidth: 226.5,
                          fullHeight: 39.775,
                          aspectRatio: 5.675
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"text"}
                  data-plasmic-override={overrides.text}
                  className={classNames(projectcss.all, sty.text)}
                >
                  <p
                    data-plasmic-name={"title9"}
                    data-plasmic-override={overrides.title9}
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.title9
                    )}
                  >
                    {
                      "MyEvaluations integrates evaluations, milestones, schedules, \nand more for streamlined medical training management."
                    }
                  </p>
                </div>
              </header>
              <div
                data-plasmic-name={"program"}
                data-plasmic-override={overrides.program}
                className={classNames(projectcss.all, sty.program)}
              >
                <div
                  data-plasmic-name={"col"}
                  data-plasmic-override={overrides.col}
                  className={classNames(projectcss.all, sty.col)}
                >
                  <div
                    data-plasmic-name={"header2"}
                    data-plasmic-override={overrides.header2}
                    className={classNames(projectcss.all, sty.header2)}
                  >
                    <h2
                      data-plasmic-name={"tagline3"}
                      data-plasmic-override={overrides.tagline3}
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.tagline3
                      )}
                    >
                      {"Program/Department Pricing"}
                    </h2>
                    <p
                      data-plasmic-name={"title2"}
                      data-plasmic-override={overrides.title2}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.title2
                      )}
                    >
                      {
                        "Prices are based on the number of trainees in a single program. New prices effective July 2024."
                      }
                    </p>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__tcxr4)}
                  >
                    <Table
                      className={classNames("__wab_instance", sty.table__uwwGx)}
                      tableLayout={
                        hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "auto"
                          : undefined
                      }
                    >
                      <TableThead
                        className={classNames(
                          "__wab_instance",
                          sty.tableThead__aXoDt
                        )}
                      >
                        <TableTr
                          className={classNames(
                            "__wab_instance",
                            sty.tableTr__slRZ
                          )}
                        >
                          <TableTh
                            className={classNames(
                              "__wab_instance",
                              sty.tableTh__rd57I
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text___6LvqN
                              )}
                            >
                              {"Program/Dept. Size"}
                            </div>
                          </TableTh>
                          <TableTh
                            className={classNames(
                              "__wab_instance",
                              sty.tableTh__s5Gcu
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__pxAwV
                              )}
                            >
                              {"Price per Month"}
                            </div>
                          </TableTh>
                        </TableTr>
                      </TableThead>
                      <TableTbody
                        className={classNames(
                          "__wab_instance",
                          sty.tableTbody__qqTpi
                        )}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return [
                                {
                                  size: "Up to 15 Trainees",
                                  price: "$249"
                                },
                                {
                                  size: "16–30 Trainees",
                                  price: " $399"
                                },
                                {
                                  size: "31–50 Trainees",
                                  price: "$549"
                                },
                                {
                                  size: "51–70 Trainees",
                                  price: "$799"
                                },
                                {
                                  size: "71–100 Trainees",
                                  price: "$1,299"
                                },
                                {
                                  size: "Above 100 Trainees",
                                  price: "$2,499"
                                }
                              ];
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <TableTr
                              className={classNames(
                                "__wab_instance",
                                sty.tableTr__x4YdP
                              )}
                              key={currentIndex}
                            >
                              <TableTd
                                alternateBackground={(() => {
                                  try {
                                    return currentIndex % 2 !== 0;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })()}
                                background={"white"}
                                className={classNames(
                                  "__wab_instance",
                                  sty.tableTd__hsEdp
                                )}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__bxXug
                                  )}
                                >
                                  <React.Fragment>
                                    {currentItem.size}
                                  </React.Fragment>
                                </div>
                              </TableTd>
                              <TableTd
                                alternateBackground={(() => {
                                  try {
                                    return currentIndex % 2 !== 0;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })()}
                                className={classNames(
                                  "__wab_instance",
                                  sty.tableTd__d4T5X
                                )}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__s8C6M
                                  )}
                                >
                                  <React.Fragment>
                                    {currentItem.price}
                                  </React.Fragment>
                                </div>
                              </TableTd>
                            </TableTr>
                          );
                        })}
                      </TableTbody>
                    </Table>
                    <div
                      data-plasmic-name={"col2"}
                      data-plasmic-override={overrides.col2}
                      className={classNames(projectcss.all, sty.col2)}
                    >
                      <div
                        data-plasmic-name={"section"}
                        data-plasmic-override={overrides.section}
                        className={classNames(projectcss.all, sty.section)}
                      >
                        <h4
                          data-plasmic-name={"title3"}
                          data-plasmic-override={overrides.title3}
                          className={classNames(
                            projectcss.all,
                            projectcss.h4,
                            projectcss.__wab_text,
                            sty.title3
                          )}
                        >
                          {"It\u2019s Really That Affordable"}
                        </h4>
                        <div
                          data-plasmic-name={"contents"}
                          data-plasmic-override={overrides.contents}
                          className={classNames(projectcss.all, sty.contents)}
                        >
                          <ListItem
                            className={classNames(
                              "__wab_instance",
                              sty.listItem___7PdvZ
                            )}
                            text={"All Use Cases"}
                          />

                          <ListItem
                            className={classNames(
                              "__wab_instance",
                              sty.listItem__ohtRr
                            )}
                            text={"No Hidden Costs"}
                          />

                          <ListItem
                            className={classNames(
                              "__wab_instance",
                              sty.listItem__mNt5F
                            )}
                            text={"Discounts for Institutional Pricing"}
                          />
                        </div>
                      </div>
                      <Button
                        data-plasmic-name={"button"}
                        data-plasmic-override={overrides.button}
                        aria-label={"Request demo"}
                        className={classNames("__wab_instance", sty.button)}
                        color={"primary"}
                        link={
                          "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                        }
                        size={"large"}
                        target={true}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___3BaMs
                          )}
                        >
                          {"Request demo"}
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"pricing"}
                data-plasmic-override={overrides.pricing}
                className={classNames(projectcss.all, sty.pricing)}
              >
                <header
                  data-plasmic-name={"header3"}
                  data-plasmic-override={overrides.header3}
                  className={classNames(projectcss.all, sty.header3)}
                >
                  <h2
                    data-plasmic-name={"tagline4"}
                    data-plasmic-override={overrides.tagline4}
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.tagline4
                    )}
                  >
                    {"Institutional Pricing"}
                  </h2>
                  <p
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {
                      "For multi-program institutions, pricing is customized based on specific requirements and scale, but always includes setup and training. Reach out to our sales representatives today to discuss your needs."
                    }
                  </p>
                </header>
                <Button
                  data-plasmic-name={"button2"}
                  data-plasmic-override={overrides.button2}
                  aria-label={"Request information"}
                  className={classNames("__wab_instance", sty.button2)}
                  color={"sky"}
                  onClick={async event => {
                    const $steps = {};

                    $steps["runOnRequestInfoClick"] = true
                      ? (() => {
                          const actionArgs = {
                            eventRef: $props["onRequestInfoClick"]
                          };
                          return (({ eventRef, args }) => {
                            return eventRef?.(...(args ?? []));
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runOnRequestInfoClick"] != null &&
                      typeof $steps["runOnRequestInfoClick"] === "object" &&
                      typeof $steps["runOnRequestInfoClick"].then === "function"
                    ) {
                      $steps["runOnRequestInfoClick"] = await $steps[
                        "runOnRequestInfoClick"
                      ];
                    }
                  }}
                  size={"large"}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5QyFy
                    )}
                  >
                    {"Request Information"}
                  </div>
                </Button>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"right"}
            data-plasmic-override={overrides.right}
            className={classNames(projectcss.all, sty.right)}
          >
            <div
              data-plasmic-name={"product2"}
              data-plasmic-override={overrides.product2}
              className={classNames(projectcss.all, sty.product2)}
            >
              <header
                data-plasmic-name={"header4"}
                data-plasmic-override={overrides.header4}
                className={classNames(projectcss.all, sty.header4)}
              >
                <div
                  data-plasmic-name={"top2"}
                  data-plasmic-override={overrides.top2}
                  className={classNames(projectcss.all, sty.top2)}
                >
                  <h3
                    data-plasmic-name={"tagline5"}
                    data-plasmic-override={overrides.tagline5}
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.tagline5
                    )}
                  >
                    {"Product"}
                  </h3>
                  <div
                    data-plasmic-name={"logo"}
                    data-plasmic-override={overrides.logo}
                    className={classNames(projectcss.all, sty.logo)}
                  >
                    <PlasmicImg__
                      alt={"MyCME logo"}
                      className={classNames(sty.img__da3Ct)}
                      displayHeight={"41.491px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"108.444px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/921ce89f8e3ca7678abf82ee467557e0.svg",
                        fullWidth: 108.444,
                        fullHeight: 41.491,
                        aspectRatio: 2.595238
                      }}
                    />
                  </div>
                </div>
                <div
                  data-plasmic-name={"text32"}
                  data-plasmic-override={overrides.text32}
                  className={classNames(projectcss.all, sty.text32)}
                >
                  <p
                    data-plasmic-name={"title5"}
                    data-plasmic-override={overrides.title5}
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.title5
                    )}
                  >
                    {
                      "MyCME makes CME event management effortless. The system tracks credits, automates ACCME reports, and streamlines cross-departmental finances."
                    }
                  </p>
                </div>
              </header>
              <div
                data-plasmic-name={"program3"}
                data-plasmic-override={overrides.program3}
                className={classNames(projectcss.all, sty.program3)}
              >
                <p
                  data-plasmic-name={"title6"}
                  data-plasmic-override={overrides.title6}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title6
                  )}
                >
                  {
                    "Pricing for MyCME is tailored to suit your specific needs, considering factors like integrated modules, departments/programs, and premium feature requirements. Connect with our sales for a personalized quote."
                  }
                </p>
                <Button
                  data-plasmic-name={"button3"}
                  data-plasmic-override={overrides.button3}
                  aria-label={"Request information"}
                  className={classNames("__wab_instance", sty.button3)}
                  color={"sky"}
                  onClick={async event => {
                    const $steps = {};

                    $steps["runOnRequestInfoClick"] = true
                      ? (() => {
                          const actionArgs = {
                            eventRef: $props["onRequestInfoClick"]
                          };
                          return (({ eventRef, args }) => {
                            return eventRef?.(...(args ?? []));
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runOnRequestInfoClick"] != null &&
                      typeof $steps["runOnRequestInfoClick"] === "object" &&
                      typeof $steps["runOnRequestInfoClick"].then === "function"
                    ) {
                      $steps["runOnRequestInfoClick"] = await $steps[
                        "runOnRequestInfoClick"
                      ];
                    }
                  }}
                  size={"large"}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__bqhor
                    )}
                  >
                    {"Request Information"}
                  </div>
                </Button>
              </div>
            </div>
            <div
              data-plasmic-name={"product3"}
              data-plasmic-override={overrides.product3}
              className={classNames(projectcss.all, sty.product3)}
            >
              <header
                data-plasmic-name={"header5"}
                data-plasmic-override={overrides.header5}
                className={classNames(projectcss.all, sty.header5)}
              >
                <div
                  data-plasmic-name={"top3"}
                  data-plasmic-override={overrides.top3}
                  className={classNames(projectcss.all, sty.top3)}
                >
                  <h3
                    data-plasmic-name={"tagline7"}
                    data-plasmic-override={overrides.tagline7}
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.tagline7
                    )}
                  >
                    {"Product"}
                  </h3>
                  <div
                    data-plasmic-name={"logo2"}
                    data-plasmic-override={overrides.logo2}
                    className={classNames(projectcss.all, sty.logo2)}
                  >
                    <PlasmicImg__
                      alt={"MyGME Fiscal logo"}
                      className={classNames(sty.img__tmG6)}
                      displayHeight={"40.02px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"195.555px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/7389eeeccb104398ba75820ba976f48f.svg",
                        fullWidth: 195.555,
                        fullHeight: 40.02,
                        aspectRatio: 4.780488
                      }}
                    />
                  </div>
                </div>
                <div
                  data-plasmic-name={"text2"}
                  data-plasmic-override={overrides.text2}
                  className={classNames(projectcss.all, sty.text2)}
                >
                  <p
                    data-plasmic-name={"title7"}
                    data-plasmic-override={overrides.title7}
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.title7
                    )}
                  >
                    {
                      "Effortlessly manage your institution's GME finances. Utilize MyGME Fiscal to unlock efficiencies through Gap & Overlap Analysis and more."
                    }
                  </p>
                </div>
              </header>
              <div
                data-plasmic-name={"program4"}
                data-plasmic-override={overrides.program4}
                className={classNames(projectcss.all, sty.program4)}
              >
                <p
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {
                    "MyGME Fiscal pricing adapts to your needs and size, accounting for integrated features and potential additions like MyQuickPass integration. Contact us for a tailored proposal."
                  }
                </p>
                <Button
                  data-plasmic-name={"button4"}
                  data-plasmic-override={overrides.button4}
                  aria-label={"Request information"}
                  className={classNames("__wab_instance", sty.button4)}
                  color={"sky"}
                  onClick={async event => {
                    const $steps = {};

                    $steps["runOnRequestInfoClick"] = true
                      ? (() => {
                          const actionArgs = {
                            eventRef: $props["onRequestInfoClick"]
                          };
                          return (({ eventRef, args }) => {
                            return eventRef?.(...(args ?? []));
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runOnRequestInfoClick"] != null &&
                      typeof $steps["runOnRequestInfoClick"] === "object" &&
                      typeof $steps["runOnRequestInfoClick"].then === "function"
                    ) {
                      $steps["runOnRequestInfoClick"] = await $steps[
                        "runOnRequestInfoClick"
                      ];
                    }
                  }}
                  size={"large"}
                  startIcon={null}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xnCu9
                    )}
                  >
                    {"Request Information"}
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <div
          data-plasmic-name={"mask"}
          data-plasmic-override={overrides.mask}
          className={classNames(projectcss.all, sty.mask)}
        >
          <RawNull
            data-plasmic-name={"rawNull"}
            data-plasmic-override={overrides.rawNull}
          />
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames(projectcss.all, sty.mobile)}
        >
          <div
            data-plasmic-name={"product4"}
            data-plasmic-override={overrides.product4}
            className={classNames(projectcss.all, sty.product4)}
          >
            <div
              data-plasmic-name={"header6"}
              data-plasmic-override={overrides.header6}
              className={classNames(projectcss.all, sty.header6)}
            >
              <div
                data-plasmic-name={"top5"}
                data-plasmic-override={overrides.top5}
                className={classNames(projectcss.all, sty.top5)}
              >
                <h3
                  data-plasmic-name={"tagline9"}
                  data-plasmic-override={overrides.tagline9}
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.tagline9
                  )}
                >
                  {"Product"}
                </h3>
                <div
                  data-plasmic-name={"containter2"}
                  data-plasmic-override={overrides.containter2}
                  className={classNames(projectcss.all, sty.containter2)}
                >
                  <div
                    data-plasmic-name={"logo5"}
                    data-plasmic-override={overrides.logo5}
                    className={classNames(projectcss.all, sty.logo5)}
                  >
                    <PlasmicImg__
                      alt={"MyEvaluations logo"}
                      className={classNames(sty.img__f65Y1)}
                      displayHeight={"39.775px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"226.5px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/ede322bb13fcecbd89105313898ea953.svg",
                        fullWidth: 226.5,
                        fullHeight: 39.775,
                        aspectRatio: 5.675
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"text3"}
                data-plasmic-override={overrides.text3}
                className={classNames(projectcss.all, sty.text3)}
              >
                <p
                  data-plasmic-name={"title10"}
                  data-plasmic-override={overrides.title10}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title10
                  )}
                >
                  {
                    "MyEvaluations integrates evaluations, milestones, schedules, \n\nand more for streamlined medical training management."
                  }
                </p>
              </div>
            </div>
            <div
              data-plasmic-name={"program2"}
              data-plasmic-override={overrides.program2}
              className={classNames(projectcss.all, sty.program2)}
            >
              <div
                data-plasmic-name={"col3"}
                data-plasmic-override={overrides.col3}
                className={classNames(projectcss.all, sty.col3)}
              >
                <div
                  data-plasmic-name={"header7"}
                  data-plasmic-override={overrides.header7}
                  className={classNames(projectcss.all, sty.header7)}
                >
                  <h2
                    data-plasmic-name={"tagline11"}
                    data-plasmic-override={overrides.tagline11}
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.tagline11
                    )}
                  >
                    {"Program/Department Pricing"}
                  </h2>
                  <p
                    data-plasmic-name={"title11"}
                    data-plasmic-override={overrides.title11}
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.title11
                    )}
                  >
                    {
                      "Prices are based on the number of trainees in a single program. New prices effective July 2024."
                    }
                  </p>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__veWWz)}>
                  <Table
                    className={classNames("__wab_instance", sty.table__byJvZ)}
                    tableLayout={
                      hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? "auto"
                        : undefined
                    }
                  >
                    <TableThead
                      className={classNames(
                        "__wab_instance",
                        sty.tableThead__sLf9M
                      )}
                    >
                      <TableTr
                        className={classNames(
                          "__wab_instance",
                          sty.tableTr__mWgJi
                        )}
                      >
                        <TableTh
                          className={classNames(
                            "__wab_instance",
                            sty.tableTh___0L6D5
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__fKpaa
                            )}
                          >
                            {"Program/Dept. Size"}
                          </div>
                        </TableTh>
                        <TableTh
                          className={classNames(
                            "__wab_instance",
                            sty.tableTh__lhGq9
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___98QX2
                            )}
                          >
                            {"Price per Month"}
                          </div>
                        </TableTh>
                      </TableTr>
                    </TableThead>
                    <TableTbody
                      className={classNames(
                        "__wab_instance",
                        sty.tableTbody__qZxhx
                      )}
                    >
                      {(_par =>
                        !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                        (() => {
                          try {
                            return [
                              {
                                size: "Up to 15 Trainees",
                                price: "$249"
                              },
                              {
                                size: "16–30 Trainees",
                                price: " $399"
                              },
                              {
                                size: "31–50 Trainees",
                                price: "$549"
                              },
                              {
                                size: "51–70 Trainees",
                                price: "$799"
                              },
                              {
                                size: "71–100 Trainees",
                                price: "$1,299"
                              },
                              {
                                size: "Above 100 Trainees",
                                price: "$2,499"
                              }
                            ];
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()
                      ).map((__plasmic_item_0, __plasmic_idx_0) => {
                        const currentItem = __plasmic_item_0;
                        const currentIndex = __plasmic_idx_0;
                        return (
                          <TableTr
                            className={classNames(
                              "__wab_instance",
                              sty.tableTr__igvdn
                            )}
                            key={currentIndex}
                          >
                            <TableTd
                              alternateBackground={(() => {
                                try {
                                  return currentIndex % 2 !== 0;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              background={"white"}
                              className={classNames(
                                "__wab_instance",
                                sty.tableTd__scnIo
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__mn31T
                                )}
                              >
                                <React.Fragment>
                                  {currentItem.size}
                                </React.Fragment>
                              </div>
                            </TableTd>
                            <TableTd
                              alternateBackground={(() => {
                                try {
                                  return currentIndex % 2 !== 0;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              className={classNames(
                                "__wab_instance",
                                sty.tableTd__b3Poj
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__jEqOg
                                )}
                              >
                                <React.Fragment>
                                  {currentItem.price}
                                </React.Fragment>
                              </div>
                            </TableTd>
                          </TableTr>
                        );
                      })}
                    </TableTbody>
                  </Table>
                  <div
                    data-plasmic-name={"col4"}
                    data-plasmic-override={overrides.col4}
                    className={classNames(projectcss.all, sty.col4)}
                  >
                    <div
                      data-plasmic-name={"section2"}
                      data-plasmic-override={overrides.section2}
                      className={classNames(projectcss.all, sty.section2)}
                    >
                      <h4
                        data-plasmic-name={"title12"}
                        data-plasmic-override={overrides.title12}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.title12
                        )}
                      >
                        {"It\u2019s Really That Affordable"}
                      </h4>
                      <div
                        data-plasmic-name={"contents2"}
                        data-plasmic-override={overrides.contents2}
                        className={classNames(projectcss.all, sty.contents2)}
                      >
                        <div
                          data-plasmic-name={"contentsItem4"}
                          data-plasmic-override={overrides.contentsItem4}
                          className={classNames(
                            projectcss.all,
                            sty.contentsItem4
                          )}
                        >
                          <div
                            data-plasmic-name={"icon4"}
                            data-plasmic-override={overrides.icon4}
                            className={classNames(projectcss.all, sty.icon4)}
                          >
                            <Icon5Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___6FbJw
                              )}
                              role={"img"}
                            />
                          </div>
                          <div
                            data-plasmic-name={"text19"}
                            data-plasmic-override={overrides.text19}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text19
                            )}
                          >
                            {"No Set-Up Fees"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"contentsItem5"}
                          data-plasmic-override={overrides.contentsItem5}
                          className={classNames(
                            projectcss.all,
                            sty.contentsItem5
                          )}
                        >
                          <div
                            data-plasmic-name={"icon5"}
                            data-plasmic-override={overrides.icon5}
                            className={classNames(projectcss.all, sty.icon5)}
                          >
                            <Icon5Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__czkkb
                              )}
                              role={"img"}
                            />
                          </div>
                          <div
                            data-plasmic-name={"text20"}
                            data-plasmic-override={overrides.text20}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text20
                            )}
                          >
                            {"No Hidden Costs"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"contentsItem6"}
                          data-plasmic-override={overrides.contentsItem6}
                          className={classNames(
                            projectcss.all,
                            sty.contentsItem6
                          )}
                        >
                          <div
                            data-plasmic-name={"icon6"}
                            data-plasmic-override={overrides.icon6}
                            className={classNames(projectcss.all, sty.icon6)}
                          >
                            <Icon5Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__whkUj
                              )}
                              role={"img"}
                            />
                          </div>
                          <div
                            data-plasmic-name={"text21"}
                            data-plasmic-override={overrides.text21}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text21
                            )}
                          >
                            {"Discounts for Institutional Pricing"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <Button
                      data-plasmic-name={"button5"}
                      data-plasmic-override={overrides.button5}
                      aria-label={"Request demo"}
                      className={classNames("__wab_instance", sty.button5)}
                      color={"primary"}
                      link={
                        "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
                      }
                      size={"large"}
                      target={true}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lg13W
                        )}
                      >
                        {"Request demo"}
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"pricing2"}
              data-plasmic-override={overrides.pricing2}
              className={classNames(projectcss.all, sty.pricing2)}
            >
              <div
                data-plasmic-name={"header8"}
                data-plasmic-override={overrides.header8}
                className={classNames(projectcss.all, sty.header8)}
              >
                <h2
                  data-plasmic-name={"tagline12"}
                  data-plasmic-override={overrides.tagline12}
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.tagline12
                  )}
                >
                  {"Institutional Pricing"}
                </h2>
                <p
                  data-plasmic-name={"title13"}
                  data-plasmic-override={overrides.title13}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title13
                  )}
                >
                  {
                    "For multi-program institutions, pricing is customized based on specific requirements and scale, but always includes setup and training. Reach out to our sales representatives today to discuss your needs."
                  }
                </p>
              </div>
              <Button
                data-plasmic-name={"button6"}
                data-plasmic-override={overrides.button6}
                aria-label={"Request information"}
                className={classNames("__wab_instance", sty.button6)}
                color={"sky"}
                onClick={async event => {
                  const $steps = {};

                  $steps["runOnRequestInfoClick"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["onRequestInfoClick"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runOnRequestInfoClick"] != null &&
                    typeof $steps["runOnRequestInfoClick"] === "object" &&
                    typeof $steps["runOnRequestInfoClick"].then === "function"
                  ) {
                    $steps["runOnRequestInfoClick"] = await $steps[
                      "runOnRequestInfoClick"
                    ];
                  }
                }}
                size={"large"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___6TDkY
                  )}
                >
                  {"Request Information"}
                </div>
              </Button>
            </div>
          </div>
          <div
            data-plasmic-name={"product5"}
            data-plasmic-override={overrides.product5}
            className={classNames(projectcss.all, sty.product5)}
          >
            <div
              data-plasmic-name={"header9"}
              data-plasmic-override={overrides.header9}
              className={classNames(projectcss.all, sty.header9)}
            >
              <div
                data-plasmic-name={"top6"}
                data-plasmic-override={overrides.top6}
                className={classNames(projectcss.all, sty.top6)}
              >
                <h3
                  data-plasmic-name={"tagline13"}
                  data-plasmic-override={overrides.tagline13}
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.tagline13
                  )}
                >
                  {"Product"}
                </h3>
                <div
                  data-plasmic-name={"logo3"}
                  data-plasmic-override={overrides.logo3}
                  className={classNames(projectcss.all, sty.logo3)}
                >
                  <PlasmicImg__
                    alt={"MyCME logo"}
                    className={classNames(sty.img__vy6)}
                    displayHeight={"41.491px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"108.444px"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/921ce89f8e3ca7678abf82ee467557e0.svg",
                      fullWidth: 108.444,
                      fullHeight: 41.491,
                      aspectRatio: 2.595238
                    }}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"text33"}
                data-plasmic-override={overrides.text33}
                className={classNames(projectcss.all, sty.text33)}
              >
                <p
                  data-plasmic-name={"title14"}
                  data-plasmic-override={overrides.title14}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title14
                  )}
                >
                  {
                    "MyCME makes CME event management effortless. The system tracks credits, automates ACCME reports, and streamlines cross-departmental finances."
                  }
                </p>
              </div>
            </div>
            <div
              data-plasmic-name={"program5"}
              data-plasmic-override={overrides.program5}
              className={classNames(projectcss.all, sty.program5)}
            >
              <p
                data-plasmic-name={"title15"}
                data-plasmic-override={overrides.title15}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.title15
                )}
              >
                {
                  "Pricing for MyCME is tailored to suit your specific needs, considering factors like integrated modules, departments/programs, and premium feature requirements. Connect with our sales for a personalized quote."
                }
              </p>
              <Button
                data-plasmic-name={"button7"}
                data-plasmic-override={overrides.button7}
                aria-label={"Request information"}
                className={classNames("__wab_instance", sty.button7)}
                color={"sky"}
                onClick={async event => {
                  const $steps = {};

                  $steps["runOnRequestInfoClick"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["onRequestInfoClick"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runOnRequestInfoClick"] != null &&
                    typeof $steps["runOnRequestInfoClick"] === "object" &&
                    typeof $steps["runOnRequestInfoClick"].then === "function"
                  ) {
                    $steps["runOnRequestInfoClick"] = await $steps[
                      "runOnRequestInfoClick"
                    ];
                  }
                }}
                size={"large"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0IB3
                  )}
                >
                  {"Request Information"}
                </div>
              </Button>
            </div>
          </div>
          <div
            data-plasmic-name={"product6"}
            data-plasmic-override={overrides.product6}
            className={classNames(projectcss.all, sty.product6)}
          >
            <div
              data-plasmic-name={"header10"}
              data-plasmic-override={overrides.header10}
              className={classNames(projectcss.all, sty.header10)}
            >
              <div
                data-plasmic-name={"top7"}
                data-plasmic-override={overrides.top7}
                className={classNames(projectcss.all, sty.top7)}
              >
                <h3
                  data-plasmic-name={"tagline15"}
                  data-plasmic-override={overrides.tagline15}
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.tagline15
                  )}
                >
                  {"Product"}
                </h3>
                <div
                  data-plasmic-name={"logo6"}
                  data-plasmic-override={overrides.logo6}
                  className={classNames(projectcss.all, sty.logo6)}
                >
                  <PlasmicImg__
                    alt={"MyGME Fiscal logo"}
                    className={classNames(sty.img__zfy3B)}
                    displayHeight={"40.02px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"195.555px"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/7389eeeccb104398ba75820ba976f48f.svg",
                      fullWidth: 195.555,
                      fullHeight: 40.02,
                      aspectRatio: 4.780488
                    }}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"text4"}
                data-plasmic-override={overrides.text4}
                className={classNames(projectcss.all, sty.text4)}
              >
                <p
                  data-plasmic-name={"title16"}
                  data-plasmic-override={overrides.title16}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.title16
                  )}
                >
                  {
                    "Effortlessly manage your institution's GME finances. Utilize MyGME Fiscal to unlock efficiencies through Gap & Overlap Analysis and more."
                  }
                </p>
              </div>
            </div>
            <div
              data-plasmic-name={"program6"}
              data-plasmic-override={overrides.program6}
              className={classNames(projectcss.all, sty.program6)}
            >
              <p
                data-plasmic-name={"title17"}
                data-plasmic-override={overrides.title17}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.title17
                )}
              >
                {
                  "MyGME Fiscal pricing adapts to your needs and size, accounting for integrated features and potential additions like MyQuickPass integration. Contact us for a tailored proposal."
                }
              </p>
              <Button
                data-plasmic-name={"button8"}
                data-plasmic-override={overrides.button8}
                aria-label={"Request information"}
                className={classNames("__wab_instance", sty.button8)}
                color={"sky"}
                onClick={async event => {
                  const $steps = {};

                  $steps["runOnRequestInfoClick"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["onRequestInfoClick"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runOnRequestInfoClick"] != null &&
                    typeof $steps["runOnRequestInfoClick"] === "object" &&
                    typeof $steps["runOnRequestInfoClick"].then === "function"
                  ) {
                    $steps["runOnRequestInfoClick"] = await $steps[
                      "runOnRequestInfoClick"
                    ];
                  }
                }}
                size={"large"}
                startIcon={null}
              >
                {"REQUEST INFORMATION"}
              </Button>
              <Button
                data-plasmic-name={"button9"}
                data-plasmic-override={overrides.button9}
                aria-label={"Request information"}
                className={classNames("__wab_instance", sty.button9)}
                color={"sky"}
                onClick={async event => {
                  const $steps = {};

                  $steps["runOnRequestInfoClick"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["onRequestInfoClick"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runOnRequestInfoClick"] != null &&
                    typeof $steps["runOnRequestInfoClick"] === "object" &&
                    typeof $steps["runOnRequestInfoClick"].then === "function"
                  ) {
                    $steps["runOnRequestInfoClick"] = await $steps[
                      "runOnRequestInfoClick"
                    ];
                  }
                }}
                size={"large"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ij7Rr
                  )}
                >
                  {"Request Information"}
                </div>
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  products: [
    "products",
    "desktop",
    "left",
    "product",
    "header",
    "top4",
    "tagline",
    "containter",
    "logo4",
    "text",
    "title9",
    "program",
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button",
    "pricing",
    "header3",
    "tagline4",
    "title4",
    "button2",
    "right",
    "product2",
    "header4",
    "top2",
    "tagline5",
    "logo",
    "text32",
    "title5",
    "program3",
    "title6",
    "button3",
    "product3",
    "header5",
    "top3",
    "tagline7",
    "logo2",
    "text2",
    "title7",
    "program4",
    "title8",
    "button4",
    "mask",
    "rawNull",
    "mobile",
    "product4",
    "header6",
    "top5",
    "tagline9",
    "containter2",
    "logo5",
    "text3",
    "title10",
    "program2",
    "col3",
    "header7",
    "tagline11",
    "title11",
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5",
    "pricing2",
    "header8",
    "tagline12",
    "title13",
    "button6",
    "product5",
    "header9",
    "top6",
    "tagline13",
    "logo3",
    "text33",
    "title14",
    "program5",
    "title15",
    "button7",
    "product6",
    "header10",
    "top7",
    "tagline15",
    "logo6",
    "text4",
    "title16",
    "program6",
    "title17",
    "button8",
    "button9"
  ],
  desktop: [
    "desktop",
    "left",
    "product",
    "header",
    "top4",
    "tagline",
    "containter",
    "logo4",
    "text",
    "title9",
    "program",
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button",
    "pricing",
    "header3",
    "tagline4",
    "title4",
    "button2",
    "right",
    "product2",
    "header4",
    "top2",
    "tagline5",
    "logo",
    "text32",
    "title5",
    "program3",
    "title6",
    "button3",
    "product3",
    "header5",
    "top3",
    "tagline7",
    "logo2",
    "text2",
    "title7",
    "program4",
    "title8",
    "button4"
  ],
  left: [
    "left",
    "product",
    "header",
    "top4",
    "tagline",
    "containter",
    "logo4",
    "text",
    "title9",
    "program",
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button",
    "pricing",
    "header3",
    "tagline4",
    "title4",
    "button2"
  ],
  product: [
    "product",
    "header",
    "top4",
    "tagline",
    "containter",
    "logo4",
    "text",
    "title9",
    "program",
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button",
    "pricing",
    "header3",
    "tagline4",
    "title4",
    "button2"
  ],
  header: [
    "header",
    "top4",
    "tagline",
    "containter",
    "logo4",
    "text",
    "title9"
  ],
  top4: ["top4", "tagline", "containter", "logo4"],
  tagline: ["tagline"],
  containter: ["containter", "logo4"],
  logo4: ["logo4"],
  text: ["text", "title9"],
  title9: ["title9"],
  program: [
    "program",
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button"
  ],
  col: [
    "col",
    "header2",
    "tagline3",
    "title2",
    "col2",
    "section",
    "title3",
    "contents",
    "button"
  ],
  header2: ["header2", "tagline3", "title2"],
  tagline3: ["tagline3"],
  title2: ["title2"],
  col2: ["col2", "section", "title3", "contents", "button"],
  section: ["section", "title3", "contents"],
  title3: ["title3"],
  contents: ["contents"],
  button: ["button"],
  pricing: ["pricing", "header3", "tagline4", "title4", "button2"],
  header3: ["header3", "tagline4", "title4"],
  tagline4: ["tagline4"],
  title4: ["title4"],
  button2: ["button2"],
  right: [
    "right",
    "product2",
    "header4",
    "top2",
    "tagline5",
    "logo",
    "text32",
    "title5",
    "program3",
    "title6",
    "button3",
    "product3",
    "header5",
    "top3",
    "tagline7",
    "logo2",
    "text2",
    "title7",
    "program4",
    "title8",
    "button4"
  ],
  product2: [
    "product2",
    "header4",
    "top2",
    "tagline5",
    "logo",
    "text32",
    "title5",
    "program3",
    "title6",
    "button3"
  ],
  header4: ["header4", "top2", "tagline5", "logo", "text32", "title5"],
  top2: ["top2", "tagline5", "logo"],
  tagline5: ["tagline5"],
  logo: ["logo"],
  text32: ["text32", "title5"],
  title5: ["title5"],
  program3: ["program3", "title6", "button3"],
  title6: ["title6"],
  button3: ["button3"],
  product3: [
    "product3",
    "header5",
    "top3",
    "tagline7",
    "logo2",
    "text2",
    "title7",
    "program4",
    "title8",
    "button4"
  ],
  header5: ["header5", "top3", "tagline7", "logo2", "text2", "title7"],
  top3: ["top3", "tagline7", "logo2"],
  tagline7: ["tagline7"],
  logo2: ["logo2"],
  text2: ["text2", "title7"],
  title7: ["title7"],
  program4: ["program4", "title8", "button4"],
  title8: ["title8"],
  button4: ["button4"],
  mask: ["mask", "rawNull"],
  rawNull: ["rawNull"],
  mobile: [
    "mobile",
    "product4",
    "header6",
    "top5",
    "tagline9",
    "containter2",
    "logo5",
    "text3",
    "title10",
    "program2",
    "col3",
    "header7",
    "tagline11",
    "title11",
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5",
    "pricing2",
    "header8",
    "tagline12",
    "title13",
    "button6",
    "product5",
    "header9",
    "top6",
    "tagline13",
    "logo3",
    "text33",
    "title14",
    "program5",
    "title15",
    "button7",
    "product6",
    "header10",
    "top7",
    "tagline15",
    "logo6",
    "text4",
    "title16",
    "program6",
    "title17",
    "button8",
    "button9"
  ],
  product4: [
    "product4",
    "header6",
    "top5",
    "tagline9",
    "containter2",
    "logo5",
    "text3",
    "title10",
    "program2",
    "col3",
    "header7",
    "tagline11",
    "title11",
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5",
    "pricing2",
    "header8",
    "tagline12",
    "title13",
    "button6"
  ],
  header6: [
    "header6",
    "top5",
    "tagline9",
    "containter2",
    "logo5",
    "text3",
    "title10"
  ],
  top5: ["top5", "tagline9", "containter2", "logo5"],
  tagline9: ["tagline9"],
  containter2: ["containter2", "logo5"],
  logo5: ["logo5"],
  text3: ["text3", "title10"],
  title10: ["title10"],
  program2: [
    "program2",
    "col3",
    "header7",
    "tagline11",
    "title11",
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5"
  ],
  col3: [
    "col3",
    "header7",
    "tagline11",
    "title11",
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5"
  ],
  header7: ["header7", "tagline11", "title11"],
  tagline11: ["tagline11"],
  title11: ["title11"],
  col4: [
    "col4",
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21",
    "button5"
  ],
  section2: [
    "section2",
    "title12",
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21"
  ],
  title12: ["title12"],
  contents2: [
    "contents2",
    "contentsItem4",
    "icon4",
    "text19",
    "contentsItem5",
    "icon5",
    "text20",
    "contentsItem6",
    "icon6",
    "text21"
  ],
  contentsItem4: ["contentsItem4", "icon4", "text19"],
  icon4: ["icon4"],
  text19: ["text19"],
  contentsItem5: ["contentsItem5", "icon5", "text20"],
  icon5: ["icon5"],
  text20: ["text20"],
  contentsItem6: ["contentsItem6", "icon6", "text21"],
  icon6: ["icon6"],
  text21: ["text21"],
  button5: ["button5"],
  pricing2: ["pricing2", "header8", "tagline12", "title13", "button6"],
  header8: ["header8", "tagline12", "title13"],
  tagline12: ["tagline12"],
  title13: ["title13"],
  button6: ["button6"],
  product5: [
    "product5",
    "header9",
    "top6",
    "tagline13",
    "logo3",
    "text33",
    "title14",
    "program5",
    "title15",
    "button7"
  ],
  header9: ["header9", "top6", "tagline13", "logo3", "text33", "title14"],
  top6: ["top6", "tagline13", "logo3"],
  tagline13: ["tagline13"],
  logo3: ["logo3"],
  text33: ["text33", "title14"],
  title14: ["title14"],
  program5: ["program5", "title15", "button7"],
  title15: ["title15"],
  button7: ["button7"],
  product6: [
    "product6",
    "header10",
    "top7",
    "tagline15",
    "logo6",
    "text4",
    "title16",
    "program6",
    "title17",
    "button8",
    "button9"
  ],
  header10: ["header10", "top7", "tagline15", "logo6", "text4", "title16"],
  top7: ["top7", "tagline15", "logo6"],
  tagline15: ["tagline15"],
  logo6: ["logo6"],
  text4: ["text4", "title16"],
  title16: ["title16"],
  program6: ["program6", "title17", "button8", "button9"],
  title17: ["title17"],
  button8: ["button8"],
  button9: ["button9"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  products: "section";
  desktop: "div";
  left: "div";
  product: "div";
  header: "header";
  top4: "div";
  tagline: "h3";
  containter: "div";
  logo4: "div";
  text: "div";
  title9: "p";
  program: "div";
  col: "div";
  header2: "div";
  tagline3: "h2";
  title2: "p";
  col2: "div";
  section: "div";
  title3: "h4";
  contents: "div";
  button: typeof Button;
  pricing: "div";
  header3: "header";
  tagline4: "h2";
  title4: "p";
  button2: typeof Button;
  right: "div";
  product2: "div";
  header4: "header";
  top2: "div";
  tagline5: "h3";
  logo: "div";
  text32: "div";
  title5: "p";
  program3: "div";
  title6: "p";
  button3: typeof Button;
  product3: "div";
  header5: "header";
  top3: "div";
  tagline7: "h3";
  logo2: "div";
  text2: "div";
  title7: "p";
  program4: "div";
  title8: "p";
  button4: typeof Button;
  mask: "div";
  rawNull: typeof RawNull;
  mobile: "div";
  product4: "div";
  header6: "div";
  top5: "div";
  tagline9: "h3";
  containter2: "div";
  logo5: "div";
  text3: "div";
  title10: "p";
  program2: "div";
  col3: "div";
  header7: "div";
  tagline11: "h2";
  title11: "p";
  col4: "div";
  section2: "div";
  title12: "h4";
  contents2: "div";
  contentsItem4: "div";
  icon4: "div";
  text19: "div";
  contentsItem5: "div";
  icon5: "div";
  text20: "div";
  contentsItem6: "div";
  icon6: "div";
  text21: "div";
  button5: typeof Button;
  pricing2: "div";
  header8: "div";
  tagline12: "h2";
  title13: "p";
  button6: typeof Button;
  product5: "div";
  header9: "div";
  top6: "div";
  tagline13: "h3";
  logo3: "div";
  text33: "div";
  title14: "p";
  program5: "div";
  title15: "p";
  button7: typeof Button;
  product6: "div";
  header10: "div";
  top7: "div";
  tagline15: "h3";
  logo6: "div";
  text4: "div";
  title16: "p";
  program6: "div";
  title17: "p";
  button8: typeof Button;
  button9: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPricingProducts__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPricingProducts__VariantsArgs;
    args?: PlasmicPricingProducts__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPricingProducts__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicPricingProducts__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPricingProducts__ArgProps,
          internalVariantPropNames: PlasmicPricingProducts__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPricingProducts__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "products") {
    func.displayName = "PlasmicPricingProducts";
  } else {
    func.displayName = `PlasmicPricingProducts.${nodeName}`;
  }
  return func;
}

export const PlasmicPricingProducts = Object.assign(
  // Top-level PlasmicPricingProducts renders the root element
  makeNodeComponent("products"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    left: makeNodeComponent("left"),
    product: makeNodeComponent("product"),
    header: makeNodeComponent("header"),
    top4: makeNodeComponent("top4"),
    tagline: makeNodeComponent("tagline"),
    containter: makeNodeComponent("containter"),
    logo4: makeNodeComponent("logo4"),
    text: makeNodeComponent("text"),
    title9: makeNodeComponent("title9"),
    program: makeNodeComponent("program"),
    col: makeNodeComponent("col"),
    header2: makeNodeComponent("header2"),
    tagline3: makeNodeComponent("tagline3"),
    title2: makeNodeComponent("title2"),
    col2: makeNodeComponent("col2"),
    section: makeNodeComponent("section"),
    title3: makeNodeComponent("title3"),
    contents: makeNodeComponent("contents"),
    button: makeNodeComponent("button"),
    pricing: makeNodeComponent("pricing"),
    header3: makeNodeComponent("header3"),
    tagline4: makeNodeComponent("tagline4"),
    title4: makeNodeComponent("title4"),
    button2: makeNodeComponent("button2"),
    right: makeNodeComponent("right"),
    product2: makeNodeComponent("product2"),
    header4: makeNodeComponent("header4"),
    top2: makeNodeComponent("top2"),
    tagline5: makeNodeComponent("tagline5"),
    logo: makeNodeComponent("logo"),
    text32: makeNodeComponent("text32"),
    title5: makeNodeComponent("title5"),
    program3: makeNodeComponent("program3"),
    title6: makeNodeComponent("title6"),
    button3: makeNodeComponent("button3"),
    product3: makeNodeComponent("product3"),
    header5: makeNodeComponent("header5"),
    top3: makeNodeComponent("top3"),
    tagline7: makeNodeComponent("tagline7"),
    logo2: makeNodeComponent("logo2"),
    text2: makeNodeComponent("text2"),
    title7: makeNodeComponent("title7"),
    program4: makeNodeComponent("program4"),
    title8: makeNodeComponent("title8"),
    button4: makeNodeComponent("button4"),
    mask: makeNodeComponent("mask"),
    rawNull: makeNodeComponent("rawNull"),
    mobile: makeNodeComponent("mobile"),
    product4: makeNodeComponent("product4"),
    header6: makeNodeComponent("header6"),
    top5: makeNodeComponent("top5"),
    tagline9: makeNodeComponent("tagline9"),
    containter2: makeNodeComponent("containter2"),
    logo5: makeNodeComponent("logo5"),
    text3: makeNodeComponent("text3"),
    title10: makeNodeComponent("title10"),
    program2: makeNodeComponent("program2"),
    col3: makeNodeComponent("col3"),
    header7: makeNodeComponent("header7"),
    tagline11: makeNodeComponent("tagline11"),
    title11: makeNodeComponent("title11"),
    col4: makeNodeComponent("col4"),
    section2: makeNodeComponent("section2"),
    title12: makeNodeComponent("title12"),
    contents2: makeNodeComponent("contents2"),
    contentsItem4: makeNodeComponent("contentsItem4"),
    icon4: makeNodeComponent("icon4"),
    text19: makeNodeComponent("text19"),
    contentsItem5: makeNodeComponent("contentsItem5"),
    icon5: makeNodeComponent("icon5"),
    text20: makeNodeComponent("text20"),
    contentsItem6: makeNodeComponent("contentsItem6"),
    icon6: makeNodeComponent("icon6"),
    text21: makeNodeComponent("text21"),
    button5: makeNodeComponent("button5"),
    pricing2: makeNodeComponent("pricing2"),
    header8: makeNodeComponent("header8"),
    tagline12: makeNodeComponent("tagline12"),
    title13: makeNodeComponent("title13"),
    button6: makeNodeComponent("button6"),
    product5: makeNodeComponent("product5"),
    header9: makeNodeComponent("header9"),
    top6: makeNodeComponent("top6"),
    tagline13: makeNodeComponent("tagline13"),
    logo3: makeNodeComponent("logo3"),
    text33: makeNodeComponent("text33"),
    title14: makeNodeComponent("title14"),
    program5: makeNodeComponent("program5"),
    title15: makeNodeComponent("title15"),
    button7: makeNodeComponent("button7"),
    product6: makeNodeComponent("product6"),
    header10: makeNodeComponent("header10"),
    top7: makeNodeComponent("top7"),
    tagline15: makeNodeComponent("tagline15"),
    logo6: makeNodeComponent("logo6"),
    text4: makeNodeComponent("text4"),
    title16: makeNodeComponent("title16"),
    program6: makeNodeComponent("program6"),
    title17: makeNodeComponent("title17"),
    button8: makeNodeComponent("button8"),
    button9: makeNodeComponent("button9"),

    // Metadata about props expected for PlasmicPricingProducts
    internalVariantProps: PlasmicPricingProducts__VariantProps,
    internalArgProps: PlasmicPricingProducts__ArgProps
  }
);

export default PlasmicPricingProducts;
/* prettier-ignore-end */
